import { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useParams } from 'react-router-dom';

import {
  Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography,
  Box,
} from '@material-ui/core';
import EditItemView from './EditItemView';
import EditDevicesView from './devices/EditDevicesView';
import { useTranslation } from './LocalizationProvider';
import { useSelector } from 'react-redux';
import { api_call, ucfirst } from './helpers/untils';
import { Stack } from '@mui/material';
import SelectField from "./form/SelectField";
import { USER_ROLE } from './config/constant';

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
}));


const UserPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const [item, setItem] = useState();
  // getDevices();
  const { id } = useParams();

  const user = useSelector((state) => state.session.user);

  const [allDevices, setAllDevices] = useState([])
  const [creditCards, setCreditCards] = useState([])

  const getDevices = async () => {
    if (id) {
      const url = `/api/get-user-page-data?userId=${id}`;
      let response = await api_call(url);
      if (response.ok) {
        const apiRes = await response.json()
        const { devices, cards } = apiRes
        setAllDevices(devices);
        setCreditCards(cards);
      } else {
        let errorMsg = "Invalid request"
        const errorRes = response
        if (errorRes['error']) {
          errorMsg = errorRes['error']
        }
        alert(errorMsg)
      }
    }
  }

  useEffect(() => {
    getDevices()
  }, [id]);

  const convertToList = (devices) => {
    var deviceList = [];
    if (Array.isArray(devices)) return devices;

    Object.keys(devices || []).forEach((key) => {
      deviceList.push(devices[key]);
    });
    return deviceList;
  };

  const getOfflineDeviceList = (devices) => {
    const deviceList = convertToList(devices);
    const offlineDeviceList = deviceList.filter((item) => item.status !== 'online')
    return offlineDeviceList;
  };

  return (
    <EditItemView endpoint="users" item={item} setItem={setItem}>
      {item
        && (
          <>
            <Accordion defaultExpanded>
              <AccordionSummary>
                <Typography variant="subtitle1">
                  Profile
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <TextField
                  margin="normal"
                  value={item.name || ''}
                  onChange={(event) => setItem({ ...item, name: event.target.value })}
                  label={t('sharedName')}
                  variant="filled"
                />
                <TextField
                  margin="normal"
                  value={item.email || ''}
                  onChange={(event) => setItem({ ...item, email: event.target.value })}
                  label={t('userEmail')}
                  variant="filled"
                  disabled={id ? true : false}
                />

                {user.administrator &&
                  (<>
                    {
                      (id) ? (
                        <></>
                      ) : (
                        <>
                          <TextField
                            margin="normal"
                            type="password"
                            onChange={(event) => setItem({ ...item, password: event.target.value })}
                            label={t('userPassword')}
                            variant="filled"
                          />
                        </>
                      )
                    }
                  </>
                  )}

                <TextField
                  margin="normal"
                  value={item.phone || ''}
                  onChange={(event) => setItem({ ...item, phone: event.target.value })}
                  label={t('sharedPhone')}
                  variant="filled"
                />
                {user.administrator &&
                  (<>
                    <SelectField
                      margin="normal"
                      value={item.role || USER_ROLE.USER}
                      emptyValue={null}
                      onChange={(event) => setItem({ ...item, role: event.target.value })}
                      data={
                        Object.keys(USER_ROLE).map((key) => {
                          return {
                            id: USER_ROLE[key],
                            name: ucfirst(USER_ROLE[key]),
                          }
                        })
                      }
                      label={`Role`}
                      variant="filled"
                    />

                    {/* <FormControlLabel
                      control={<Checkbox checked={item.administrator} onChange={(event) => setItem({ ...item, administrator: event.target.checked })} />}
                      label="Administrator"
                    /> */}
                    {
                      (id && allDevices.length > 0) && (
                        <>
                          <Box style={{ paddingTop: '8px' }}>
                            <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`}>
                              <Typography variant="subtitle1">
                                Devices
                              </Typography>
                              <Typography variant="subtitle1">
                                <span>{getOfflineDeviceList(item.devices).length}</span> / <span>{convertToList(item.devices).length}</span>
                              </Typography>
                            </Stack>
                          </Box>
                          <EditDevicesView
                            devices={item.devices}
                            setDevices={(devices) => setItem({ ...item, devices })}
                            definitions={allDevices}
                            userInfo={item}
                            creditCards={creditCards}
                          />
                        </>
                      )
                    }
                  </>
                  )}
              </AccordionDetails>
            </Accordion>
          </>
        )}
    </EditItemView>
  );
};

export default UserPage;
